import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as DeleteIcon } from "../assets/delete.svg";
import {
  BackgroundLayout,
  FilledButton,
  ItemField,
  ItemText,
  PageLayout,
  TextField,
  TitleText,
  VerticalGap,
  TableDataText,
  TableItemText,
  TableDataButton,
  TablePageButton,
} from "../component";

import { adminTableItems } from "../assets/data";
import { axiosInstance } from "../axiosConfig";

const AdminScreen = () => {
  const [newId, setNewId] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newName, setNewName] = useState("");

  const [totalPage, setTotalPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);

  const [adminData, setAdminData] = useState([]);
  const [addDisabled, setAddDisabled] = useState(true);

  const generateUser = async () => {
    let id;
    let password;
    let idExists = true;
    setAddDisabled(true);

    while (idExists) {
      id = "krpt" + Math.floor(Math.random() * 100000).toString();

      try {
        await axiosInstance.post(
          `${process.env.REACT_APP_BASE_URL}/user/checkId`,
          { id }
        );
        idExists = false;
      } catch (err) {
        idExists = true;
      }
    }

    password = Math.random().toString(36).slice(2);
    setNewId(id);
    setNewPassword(password);
    setAddDisabled(false);
  };

  const addUser = async () => {
    const data = {
      id: newId,
      password: newPassword,
      name: newName,
    };

    try {
      await axiosInstance.post(
        `${process.env.REACT_APP_BASE_URL}/user/register`,
        data
      );
      alert("사용자가 등록되었습니다");
      setNewId("");
      setNewPassword("");
      setNewName("");
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}/user/totalPage`, {
        headers: {
          Authorization: `${localStorage.getItem("accessToken")}`,
        },
      })
      .then((res) => {
        setTotalPage(res.data.totalPage);
      });
  }, []);

  useEffect(() => {
    axiosInstance
      .get(`${process.env.REACT_APP_BASE_URL}/user/list`, {
        headers: {
          Authorization: `${localStorage.getItem("accessToken")}`,
        },
        params: {
          page: currentPage,
        },
      })
      .then((res) => {
        setAdminData(res.data);
      });
  }, [currentPage]);

  return (
    <PageLayout>
      <TitleText>사용자 등록</TitleText>
      <VerticalGap height="10px" />
      <BackgroundLayout>
        <form
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
          }}
        >
          <AdminText>아이디 </AdminText>
          <AdminItemField>{newId}</AdminItemField>
          <AdminText>비밀번호 </AdminText>
          <AdminItemField>{newPassword}</AdminItemField>
          <AdminText>이름</AdminText>

          <TextField
            type="text"
            placeholder="이름을 입력하세요"
            onChange={(e) => {
              setNewName(e.target.value);
            }}
          />
          <FilledButton
            type="button"
            onClick={() => {
              generateUser();
            }}
          >
            자동 생성
          </FilledButton>
          <FilledButton
            type="submit"
            disabled={addDisabled}
            onClick={() => {
              if (newName === "") {
                alert("이름을 입력하세요");
                return;
              }
              addUser();
            }}
          >
            등록
          </FilledButton>
        </form>
      </BackgroundLayout>
      <VerticalGap height="30px" />
      <TitleText>사용자 관리</TitleText>
      <VerticalGap height="10px" />
      <AdminTable items={adminTableItems} data={adminData} />
      <VerticalGap height="30px" />
      <TablePageButton
        totalPage={totalPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </PageLayout>
  );
};

const AdminTable = ({ items, data }) => {
  const handleDelete = (id) => async () => {
    if (window.confirm(`사용자 ${id}를 삭제하시겠습니까?`)) {
      try {
        await axiosInstance.delete(
          `${process.env.REACT_APP_BASE_URL}/user/delete`,
          {
            headers: {
              Authorization: `${localStorage.getItem("accessToken")}`,
            },
            data: {
              id,
            },
          }
        );
        alert(`삭제되었습니다`);
        window.location.reload();
      } catch (err) {
        console.error(err);
      }
    }
  };

  return (
    <TableLayout>
      {Object.keys(items).map((item, index) => (
        <TableItemText>{items[item]}</TableItemText>
      ))}
      {data.map((item, index) => (
        <>
          <TableDataText
            style={{
              justifyContent: "center",
              backgroundColor: "var(--color-background)",
            }}
          >
            {item.index}
          </TableDataText>
          <TableDataText>{item.id}</TableDataText>
          <TableDataText
            style={{
              justifyContent: "center",
            }}
          >
            {item.name}
          </TableDataText>
          <TableDataText
            style={{
              justifyContent: "center",
            }}
          >
            {item.role}
          </TableDataText>
          <TableDataText
            style={{
              justifyContent: "center",
            }}
          >
            {item.created_at ? item.created_at.slice(0, 10) : null}
          </TableDataText>
          <TableDataText style={{ justifyContent: "center" }}>
            {index > 0 ? (
              <TableDataButton onClick={handleDelete(item.id)}>
                <DeleteIcon style={{ width: "20px" }} />
              </TableDataButton>
            ) : null}
          </TableDataText>
        </>
      ))}
    </TableLayout>
  );
};

const TableLayout = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 6fr 6fr 2fr 4fr 1fr;
  justify-content: center;
  align-items: center;
  background-color: var(--color-background);
  border-top: 1px solid var(--color-gray);

  & > div {
    border-right: 1px solid var(--color-gray);
    border-bottom: 1px solid var(--color-gray);
  }

  & > div:nth-child(6n + 1) {
    border-left: 1px solid var(--color-gray);
  }

  & > div:nth-child(6n) {
    border-right: 1px solid var(--color-gray);
  }
`;

const AdminText = styled(ItemText)`
  width: auto;
  white-space: nowrap;
`;

const AdminItemField = styled(ItemField)`
  width: 300px;
  margin-right: 20px;
`;

export default AdminScreen;
